import { Box, Typography, IconButton } from '@mui/material';
import { GearIcon } from '@phosphor-icons/react';
import { useState } from 'react';
import HideActionConfig from './HideActionConfig';

interface UnderDevelopmentProps {
  showSettings?: boolean;
}

const UnderDevelopment = ({ showSettings }: UnderDevelopmentProps) => {
  const [showHideActionConfig, setShowHideActionConfig] = useState(false);

  const handleShowHideActionConfig = () => {
    setShowHideActionConfig(true);
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          p: 3,
          textAlign: 'center',
          width: '100%',
          position: 'relative',
        }}
      >
        {showSettings && (
          <IconButton
            sx={{
              position: 'absolute',
              top: 16,
              right: 16,
              color: 'text.secondary',
            }}
            onClick={handleShowHideActionConfig}
          >
            <GearIcon />
          </IconButton>
        )}

        <Typography
          variant="h5"
          gutterBottom
          sx={{ fontSize: '20px', textAlign: 'center' }}
        >
          Page Under Development
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          align="center"
          sx={{ fontSize: '14px' }}
        >
          This page is under development and will be available soon. We're
          working hard to create an experience for you. Stay tuned for updates!
        </Typography>
      </Box>
      <HideActionConfig
        open={showHideActionConfig}
        onClose={() => setShowHideActionConfig(false)}
      />
    </>
  );
};

export default UnderDevelopment;
